import { render, staticRenderFns } from "./CustomerOdontoImplants.vue?vue&type=template&id=0c3caa5d"
import script from "./CustomerOdontoImplants.vue?vue&type=script&lang=js"
export * from "./CustomerOdontoImplants.vue?vue&type=script&lang=js"
import style0 from "./CustomerOdontoImplants.vue?vue&type=style&index=0&id=0c3caa5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports